<!-- @format -->

<template>
	<disabled-text
		v-if="disabled && showDisabledText"
		:value="
			value && props.isTimestamp
				? dayjs(value).format(props.format)
				: props.type === 'time'
				? (value && dayjs(value).format(props.format)) || ''
				: value?.toString() || ''
		"
	/>
	<template v-else>
		<template v-if="type === 'time'">
			<el-time-picker v-model="value" :format="format" :disabled="disabled" v-bind="$attrs" />
		</template>

		<template v-else>
			<el-date-picker
				v-model="value"
				:disabled="disabled"
				:type="type"
				:format="format"
				:value-format="isTimestamp ? 'x' : format"
				unlink-panels
				placeholder="请选择日期时间"
				v-bind="$attrs"
			/>
		</template>
	</template>
</template>

<script setup lang="ts">
	import dayjs from 'dayjs';
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: any;
		type:
			| 'datetime'
			| 'date'
			| 'year'
			| 'month'
			| 'dates'
			| 'week'
			| 'datetimerange'
			| 'daterange'
			| 'monthrange'
			| 'time';
		format: string;
		disabled?: boolean;
		showDisabledText?: boolean;
		isTimestamp?: boolean;
		isTenTimestamp?: boolean;
	}
	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
		isTimestamp: false,
		isTenTimestamp: false,
	});

	const emit = defineEmits(['update:modelValue']);

	const getValue = (value) => {
		return value && props.isTimestamp
			? props.isTenTimestamp
				? +`${value}000`
				: +value
			: props.type === 'time'
			? (value && dayjs(value, props.format)) || ''
			: value;
	};

	const setValue = (value) => {
		return value && props.isTimestamp
			? props.isTenTimestamp
				? dayjs(value).unix()
				: dayjs(value).valueOf()
			: props.type === 'time'
			? (value && dayjs(value).format(props.format)) || ''
			: value || '';
	};

	const value = computed({
		get() {
			if (['datetimerange', 'daterange', 'monthrange'].includes(props.type)) {
				if (props.modelValue) {
					const arr = props.modelValue.split(',');
					return [getValue(arr[0] || ''), getValue(arr[1] || '')];
				} else {
					return [];
				}
			} else {
				return getValue(props.modelValue);
			}
		},
		set(val) {
			if (['datetimerange', 'daterange', 'monthrange'].includes(props.type) && val) {
				const value = [setValue(val[0]), setValue(val[1])];
				emit('update:modelValue', value.toString());
			} else {
				emit('update:modelValue', setValue(val));
			}
		},
	});
</script>

<style scoped lang="scss"></style>
